import { BaseGetRequest } from './core/baseGetRequest';
import { AccountNotificationsList, AccountNotificationsListDynamicType} from 'acscp/api/models/accountNotificationsList';
import { Authentication } from './core/baseRequest';

export class AccountNotificationsRequest extends BaseGetRequest<AccountNotificationsList> {
    constructor() {
        super('notifications', {}, AccountNotificationsListDynamicType, Authentication.SharingToken);
    }
}
